import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M14.69 2a1.29 1.29 0 0 0-1.17-.63h-11a1.28 1.28 0 0 0-1.2.63 1.46 1.46 0 0 0 .14 1.53C1.79 4.07 5 8.92 5.65 10v3.1a1.46 1.46 0 0 0 1.65 1.65h1.41a1.46 1.46 0 0 0 1.65-1.65V10c.68-1 3.85-5.89 4.19-6.43A1.46 1.46 0 0 0 14.69 2ZM9 9.32a.79.79 0 0 0-.12.42v3.5H7.16a.53.53 0 0 1 0-.14V9.74A.79.79 0 0 0 7 9.32c0-.05-3.55-5.41-4.21-6.45h10.4C12.53 3.92 9 9.27 9 9.32Z';
const draw24px =
  'M21.5,3.54a1.53,1.53,0,0,0-1.4-.73H3.91a1.52,1.52,0,0,0-1.4.73A1.77,1.77,0,0,0,2.7,5.43c.5.82,5.34,8.2,6.2,9.51v4.72c0,1.82,1.11,2.06,2.07,2.06h.91a.25.25,0,0,0,.12,0,.25.25,0,0,0,.12,0H13c1,0,2.07-.24,2.07-2.06V14.94c.86-1.31,5.7-8.69,6.2-9.51A1.81,1.81,0,0,0,21.5,3.54ZM20,4.65c-.52.85-6.24,9.57-6.29,9.66a.74.74,0,0,0-.13.41v4.94a1.23,1.23,0,0,1-.06.5,1.15,1.15,0,0,1-.51.06h-.91a.25.25,0,0,0-.12,0,.25.25,0,0,0-.12,0H11c-.45,0-.5,0-.5,0a1.05,1.05,0,0,1-.07-.51V14.72a.73.73,0,0,0-.12-.41C10.22,14.22,4.5,5.5,4,4.65a1.19,1.19,0,0,1-.15-.34H20.17A1,1,0,0,1,20,4.65Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const FunnelIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'funnel'),
) as IconWithRender;

FunnelIcon.displayName = 'FunnelIcon';
FunnelIcon.propTypes = Icon.propTypes;
FunnelIcon.renderIcon = (props) => <FunnelIcon {...props} />;
export default FunnelIcon;
